module.exports = __webpack_public_path__ + "img/1003.2c50122d.jpg";